var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Rider Directory',"subtitle":'Add New Rider'}}),_c('rider-form',{attrs:{"banks":_vm.banks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }